import {
  ExternalChatOrganization,
  ExternalChatChannel,
  ExternalChatUserState,
} from "domain-entities";
import { DocumentStore } from "Helpers/StoreHelper";
import { firestore } from "firebase/app";
import { useViewer } from "Components/Auth/AuthProvider";

export function useReadChannel(
  userStateStore: DocumentStore<ExternalChatUserState>
) {
  const viewer = useViewer();

  return (
    organization: ExternalChatOrganization,
    channel: ExternalChatChannel
  ) => {
    if (userStateStore.item) {
      const isChannelUnread = userStateStore.item.unreadChannels.includes(
        `${organization.id}/${channel.id}`
      );

      if (isChannelUnread) {
        userStateStore.updateItem(
          {
            unreadChannels: firestore.FieldValue.arrayRemove(
              `${organization.id}/${channel.id}`
            ) as any,
          },
          viewer.user.uid
        );
      }
    }
  };
}
